import { getAPIURL, getBaseURL } from '../../GlobalComponents/URLs'
import { getCurrentUser } from './metaSlice'

export interface User {
    CompanyCode: string
    Username: string
    Firstname: string
    Lastname: string
    Email: string
    TelephoneNumber: string
    Warehouse: string
    Position: string
}
// export interface User {
//     User: {
//         CompanyCode: string
//         Username: string
//         CompanyName: string
//         Firstname: string
//         Lastname: string
//         Email: string
//         Warehouse: string
//         WarehouseName: string
//         EmployeeNo: string
//         TelephoneNumber: string
//         Extension: string
//         FaxNumber: string
//         ID: number
//         EmailSurveyCC: string
//         PublishCellPhone: boolean
//         PublishHomePhone: boolean
//         isLinkedToPayroll: boolean
//         HomeWarehouse: string
//         EmailQuoteFollowUp: boolean
//         IsInactive: boolean
//         HRCompanyCode: string
//         CellPhoneCarrierID: number
//         SMSAlerts: boolean
//         CellPhoneCarrierName: string
//         RowError?: string
//         RowState?: number
//         Table?: Array<User>
//         ItemArray?: Array<any>
//         HasErrors?: boolean
//     }
// }
// export const cancelSearch = () => initController.abort()
export const fetchGetCurrentUser = async (): Promise<User> => {
    let url = getAPIURL() + 'user/CurrentUser'
    let req = await fetch(url, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
    })
    if (req.status === 400) {
        // window.location.href =
        //     getBaseURL() + `masterclient/main.aspx?redirect=${getBaseURL()}/FastQuote`

        let redirectURL = `${getBaseURL()}masterclient/main.aspx?redirect=${encodeURIComponent(
            window.location.href
        )}`
        window.location.href = redirectURL
    }

    return req.json()
}
interface FetchPermissionsParams {
    Company: string
    Username: string
    Domain: string
    Ability: string
}
const fetchPermissions = async (payload: FetchPermissionsParams): Promise<string | null> => {
    let url = getAPIURL() + 'master/GetUserPermissions'

    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })

    let json = await req.json()
    return json
}

export const hasFastQuotePermissions = async () => {
    const currentUser = await getCurrentUser()
    const permissions = await fetchPermissions({
        Company: currentUser.CompanyCode,
        Username: currentUser.Username,
        Domain: 'ORDERPROCESSING',
        Ability: 'FAST QUOTE',
    })
    return permissions === '' ? true : false
}

export const hasAOPPermissions = async () => {
    const currentUser = await getCurrentUser()
    let permissions = await fetchPermissions({
        Company: currentUser.CompanyCode,
        Username: currentUser.Username,
        Domain: 'SALES',
        Ability: 'AOP',
    })
    return permissions === null ? false : true
}

export const hasTechPartnerDashboardPermissions = async () => {
    const currentUser = await getCurrentUser()
    let permissions = await fetchPermissions({
        Company: currentUser.CompanyCode,
        Username: currentUser.Username,
        Domain: 'SALES',
        Ability: 'TECH PARTNER DASHBOARD ACCESS', // see if they are mat. mgr. #11291
    })
    return permissions === null ? false : true
}

export const hasPOSManagerPermissions = async () => {
    const currentUser = await getCurrentUser()
    let permissions = await fetchPermissions({
        Company: currentUser.CompanyCode,
        Username: currentUser.Username,
        Domain: 'SALES',
        Ability: 'POINT OF SALE MANAGER',
    })
    return permissions === null ? false : true
}

export const isWebUser = (): boolean => {
    return document.getElementById('web-body') !== null
}

export const browserCache = {
    getItem(key: string) {
        const itemStr = localStorage.getItem(key)

        // if the item doesn't exist, return null
        if (!itemStr) return null

        const item = JSON.parse(itemStr)
        const now = new Date()

        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(key)
            return null
        }
        return item.value
    },

    setItem(key: string, value: any, maxAgeInMs = 30 * 60 * 60 * 1000) {
        const now = new Date()

        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        const item = {
            value: value,
            expiry: now.getTime() + maxAgeInMs,
        }
        localStorage.setItem(key, JSON.stringify(item))
    },
}
